<template>
  <main
    role="main"
    class="template-page intro"
    aria-label="map panel"
    aria-describedby="istruzioni"
  >
    <p class="tohide" tabindex="-1" id="istruzioni">
      use arrows to navigate, plus and minus to change zoom, press 'M' to focus
      map, measure distance widget not available for keyboard, press 'N' to
      return to navigation
    </p>

    <div id="inform" class="esri-widget">
      <h3>Search</h3>
      <h4>
        <ul>
          <li>Use the Search box in the top left corner to find a property. You can search by address or owner name.</li>
          <li>Select the corresponding address or parcel owner name by clicking on the result.</li>
          <li>Click on the parcel to open the details window.</li>
        </ul>
      </h4>
      <!--
      <h3>Comments</h3>
      <h4>
        <ul>
          <li>
            To leave a comment tied to the searched parcel, click the Comment link in the parcel details window and compile the form.  
          </li>
          <li>
            If you want to provide a comprehensive feedback, please fill out the
            questionnaire
          </li>
          <li>To compile the questionaire <a :href="this.content.intro.surveyLink" target="_blank">click here</a></li>
        </ul>
      </h4>
      -->
      <!--<h3>Feedback</h3>
      <h4>
        <ul>
          <li>
            If you want to provide a comprehensive feedback, please fill out the
            questionnaire
          </li>
          <li>To compile the questionaire <a :href="this.content.intro.surveyLink" target="_blank">click here</a></li>
        </ul>
      </h4>-->
    </div>

    <div :class="['main-content', 'map-wrapper', 'lang-' + this.lang]">
      <div id="loader" class="loader">
        <p>{{ this.lang == "es" ? "Cargando . . ." : "Loading . . ." }}</p>
      </div>

      <div id="viewDiv"></div>

      <div id="info" aria-hidden="true" tabindex="-1">
        <button
          id="close-spalla"
          tabindex="0"
          class="close"
          aria-label="close panel"
          @click="hideInfo()"
        ></button>
        <div class="intro" tabindex="0">
          <h2 style="color: #fff" id="name"></h2>
        </div>

        <p id="objectid"></p>

        <article id="category" tabindex="0">no data</article>

        <button
          id="comment-button"
          aria-label="toggle comment form"
          tabindex="0"
          @click="toggleComment()"
          :class="{ drop: this.showCommentSection }"
        >
          Comment
        </button>

        <article
          tabindex="0"
          aria-label="leave a comment form"
          v-if="this.showCommentSection"
          id="comment-section"
          aria-controls="comment-button"
          :aria-hidden="!this.showCommentSection"
        >
          <form class="comment-form" action="#" @submit.prevent>
            <div class="form-row">
              <div class="campo">
                <label for="name">First Name</label>
                <input
                  type="text"
                  placeholder=""
                  id="name-field"
                  name="name"
                  value=""
                  v-model="formData.Name"
                />
              </div>
              <div class="campo">
                <label for="surname">Last Name</label>
                <input
                  type="text"
                  placeholder=""
                  id="surname-field"
                  name="surname"
                  value=""
                  v-model="formData.Surname"
                />
              </div>
            </div>
            <div class="campo">
              <label for="comments">Comment</label>
              <textarea
                name="comments"
                id="comment-field"
                placeholder=""
                aria-label=""
                value=""
                v-model="formData.Comment"
                rows="5"
              ></textarea>
            </div>
            <div class="buttons">
              <button class="light">Cancel</button>
              <button type="submit" @click="submitForm">Send</button>
            </div>
          </form>
        </article>

        <article
          tabindex="0"
          aria-label="leave a comment form"
          v-if="this.showCommentSuccess"
          id="comment-section"
          aria-controls="comment-button"
          :aria-hidden="!this.showCommentSuccess"
        >
          <h2>Thanks for your comment!</h2>
          <h4>Please provide more information by completing the project <a :href="this.content.intro.surveyLink" target="_blank">questionnaire</a>.</h4>
        </article>
      </div>

      <!-- <div id="measure">
        <button
          aria-hidden="true"
          tabindex="-1"
          class="esri-icon-measure-line"
          id="distanceButton"
          title="Measure distance between two or more points"
        ></button>
      </div> -->

      <div id="zoomer">
        <button
          class="esri-icon-plus"
          @click="zoomplus()"
          aria-label="zoom in"
        ></button>
        <button
          class="esri-icon-minus"
          @click="zoomminus()"
          aria-label="zoom out"
        ></button>
      </div>

      <!-- <button
        id="zoomout"
        @click="zoomOut()"
        class="esri-icon-zoom-out-fixed"
        aria-label="reset zoom"
      ></button> -->
    </div>

    <button
      class="tohide"
      id="back-to-nav"
      @click="backtomap()"
      tabindex="0"
      aria-label="back to navbar"
    >
      back to map
    </button>
    <button
      class="tohide"
      id="back-to-nav"
      @click="backtonav()"
      tabindex="0"
      aria-label="back to navbar"
    >
      back to navbar
    </button>
  </main>
</template>

<script>
import path from "path";
import Map from "@arcgis/core/Map";
import MapView from "@arcgis/core/views/MapView";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";

import GeometryService from "@arcgis/core/tasks/GeometryService";
import ProjectParameters from "@arcgis/core/tasks/support/ProjectParameters";

import Zoom from "@arcgis/core/widgets/Zoom";
//import ZoomViewModel from "@arcgis/core/widgets/Zoom/ZoomViewModel";
import Search from "@arcgis/core/widgets/Search";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import BasemapGallery from "@arcgis/core/widgets/BasemapGallery";

import Home from "@arcgis/core/widgets/Home.js";

import Expand from "@arcgis/core/widgets/Expand";
import Graphic from "@arcgis/core/Graphic";
import Legend from "@arcgis/core/widgets/Legend";
import Locator from "@arcgis/core/tasks/Locator";

import PictureMarkerSymbol from "@arcgis/core/symbols/PictureMarkerSymbol.js";

import SimpleMarkerSymbol from "@arcgis/core/symbols/SimpleMarkerSymbol";
import SimpleLineSymbol from "@arcgis/core/symbols/SimpleLineSymbol";
import Color from "@arcgis/core/Color";
import PopupTemplate from "@arcgis/core/PopupTemplate.js";


//import axios from 'axios';

export default {
  name: "location",
  data: () => {
    return {
      view: null,
      map: null,
      zoomViewModel: null,
      workspacesLayer: null,
      pipelineLayer: null,
      citiesLayer: null,
      multiterminalLayer: null,
      valvesLayer: null,
      popsAdded: false,
      activeWidget: null,
      lastbutton: null,
      showspalla: false,

      showCommentSection: false,
      showCommentSuccess: false,
      formData: {
        Name: "",
        Surname: "",
        Comment: "",
        Field: "",
        Comment_Date: null,
      },
      geometryData: null,

      substationsLayer: null,
      proposedLayer: null,
      trasmlineLayer: null,
      parcelLayer: null,
      corridorLayer: null,
      commentsLayer: null,

      searchLayer: null,
      /*
      layers: {
        substations: { id: 0 },
        proposed: { id: 1 },
        trasmline: { id: 2 },
        parcel: { id: 3 },
        corridor: { id: 4 },
        comments: { id: 6 },
      },
      */
      //urlBase:
      //  "https://services1.arcgis.com/HGtSnUkjNnIpVEaA/arcgis/rest/services/DUKE_Sparr/FeatureServer/",
      //urlComments:
      //  "https://services1.arcgis.com/HGtSnUkjNnIpVEaA/arcgis/rest/services/19123401_Webmap_Content_DRAFT_20220111_Sparr/FeatureServer/2/addFeatures",
    };
  },
  computed: {
    lang () {
      return this.$store.state.lang
    },
    content () {
      return this.$store.state.data[this.proj][this.lang]
    },
    contentGen () {
      return this.$store.state.data[this.proj]
    },
    proj() {
      return this.$store.state.project
    },
    urlBase(){
      return this.contentGen.esri.urlBase
    },
    urlComments(){
      return this.contentGen.esri.urlComments
    },
    center(){
      return this.contentGen.esri.center
    },
    layers() {
      let layersx = null
      console.log('this.proj:', this.proj);
      if(this.proj == 'sparr') {

        layersx =  {
          substations: { id: 5 },
          proposed: { id: 1 },
          trasmline: { id: 6 },
          parcel: { id: 3 },
          corridor: { id: 4 },
          comments: { id: 2 }
        }

      } else if(this.proj == 'dwdv'){
        layersx =  {
          substations: { id: 5 },
          proposed: { id: 25 },
          trasmline: { id: 6 },
          parcel: { id: 24 },
          corridor: { id: 27 },
          comments: { id: 9 }
        }
      }
       return layersx
    }
  },
  methods: {
    submitForm() {
      this.formData.Comment_Date = new Date();
      console.log({
        attributes: this.formData,
        geometry: this.geometryData
      })
      const addFeature = new Graphic({
        attributes: this.formData,
        geometry: this.geometryData
      });
      console.log([addFeature])
      let _this = this;
      this.commentsLayer
        .applyEdits({
          addFeatures: [addFeature],
        })
        .then(function (results) {
          _this.formData = {
            Name: "",
            Surname: "",
            Comment: "",
            Field: "",
            Comment_Date: null,
          };

          _this.showCommentSection = false;
          _this.showCommentSuccess = true;
        });
    },
    toggleComment() {
      this.showCommentSuccess = false;
      this.showCommentSection = !this.showCommentSection;
    },
    backtonav() {
      document.getElementById("navigazione").focus();
    },
    zoomplus() {
      this.zoomViewModel.zoomIn();
    },
    zoomminus() {
      this.zoomViewModel.zoomOut();
    },
    zoomOut() {
      if (
        this.workspacesLayer.fullExtent.spatialReference !=
        this.view.SpatialReference
      ) {
        var geomSer = new GeometryService({
          url: "http://sampleserver6.arcgisonline.com/arcgis/rest/services/Utilities/Geometry/GeometryServer",
        });
        var params = new ProjectParameters({
          geometries: [this.workspacesLayer.fullExtent],
          outSpatialReference: this.view.spatialReference,
        });
        var tot = this;
        geomSer.project(params).then(function (results) {
          tot.view.goTo(
            {
              target: results[0],
              zoom: 11.989,
            },
            {
              animate: true,
              duration: 1500,
            }
          );
        });
      } else {
        this.view.goTo(
          {
            target: this.workspacesLayer.fullExtent,
            zoom: 11.989,
          },
          {
            animate: true,
            duration: 1500,
          }
        );
      }
    },
    createMapAndLayers() {
      this.substationsLayer = new FeatureLayer({
        url: this.urlBase + this.layers.substations.id,
        outFields: ["*"],
        labelsVisible: false
      });

      this.proposedLayer = new FeatureLayer({
        url: this.urlBase + this.layers.proposed.id,
        outFields: ["*"],
        definitionExpression: "LOC_TYPE = 'ROW'"
      });

      this.proposedLayer.renderer = {
        type: "simple",
        symbol: {
          type: "simple-fill",
          color: new Color([115, 255, 223, 0.7]),
          outline: {
            color: new Color([115, 255, 223, 1]),
            width: 2
          }
        }
      };

      const simpleLineSymbol = new SimpleLineSymbol({
        cap: "butt",
        color: new Color([0,122,194,1]),
        join: "round",
        miterLimit: 1,
        style: "long-dash",
        width: 2
      });

      this.trasmlineLayer = new FeatureLayer({
        url: this.urlBase + this.layers.trasmline.id,
        outFields: ["*"],
        //labelingInfo: [labelClass]
      });

      this.trasmlineLayer.renderer = {
        type: "simple",
        symbol: simpleLineSymbol
      };

      //this.trasmlineLayer.labelingInfo[0].labelPlacement = 'above-center'
      //console.log('object :>> ', this.trasmlineLayer);
      this.parcelLayer = new FeatureLayer({
        url: this.urlBase + this.layers.parcel.id,
        outFields: ["*"],
        popupTemplate: {
          // autocasts as new PopupTemplate()
          title: "ok",
          overwriteActions: true,
        },
        visible: false,
      });

      this.commentsLayer = new FeatureLayer({
        url: this.urlBase + this.layers.comments.id,
        outFields: ["*"],
        visible: true,
        popupTemplate :{
          title: "ok",
          overwriteActions: true,
          }
      });

      this.corridorLayer = new FeatureLayer({
        url: this.urlBase + this.layers.corridor.id,
        outFields: ["*"],
      });

      this.searchLayer = new GraphicsLayer({
        graphics: [],
      });

      this.map = new Map({
        basemap: "topo-vector",
        layers: [
          this.parcelLayer,
          //this.corridorLayer,
          this.proposedLayer,
          this.trasmlineLayer,
          // this.commentsLayer,
          this.substationsLayer
        ],
      });

      this.view = new MapView({
        container: "viewDiv",
        map: this.map,
        center: [-81.300, 28.944283],
        //center: this.center,
        zoom: 11,
        highlightOptions: {
          color: "#ff0000",
          haloColor: "#00ff00",
        },
        popup: {
          dockEnabled: false,
          dockOptions: {
            breakpoint: false,
            buttonEnabled: false,
            position: "top-center",
            autoOpenEnabled: true,
            actions: [],
            overwriteActions: true,
            includeDefaultActions: false,
          },
        },
      });

      let basemapGallery = new BasemapGallery({
        view: this.view,
      });

      let basemapExpand = new Expand({
        expandIconClass: "esri-icon-basemap", // see https://developers.arcgis.com/javascript/latest/guide/esri-icon-font/
        // expandTooltip: "Expand LayerList", // optional, defaults to "Expand" for English locale
        view: this.view,
        content: basemapGallery
      });

      console.log('parcel :>> ', this.parcelLayer);

      const sources = [
        {
          layer: this.parcelLayer,
          // searchFields: ["o_name1", "o_address1"],
          searchFields: ["pid", "o_address1", "s_address1"],
          displayField: "s_address1",
          exactMatch: false,
          outFields: ["*"],
          name: "Parcels Results",
          placeholder: "Find address, place, or parcel ID",
          maxResults: 6,
          maxSuggestions: 6,
          suggestionsEnabled: true,
          suggestionTemplate: "<b>Parcel ID:</b> {pid}<br> <i>{s_address1}</i>",
          minSuggestCharacters: 0,
          zoomScale: 2000,
          resultSymbol: {
            type: "picture-marker", // autocasts as new PictureMarkerSymbol()
            url: "https://developers.arcgis.com/javascript/latest//sample-code/widgets-search-multiplesource/live/images/senate.png",
            height: 36,
            width: 36,
          },
        }, {
        //Pass in the custom locator to the sources
        locator: new Locator({
            url: "http://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer",
            popupTemplate: { overwriteActions: true },
        }),
        name: "Address Results",
        outFields: ["Match_addr"],
    }
      ];

      const searchWidget = new Search({
        activeSourceIndex: -1,
        view: this.view,
        sources: sources,
        includeDefaultSources: false
      });

      searchWidget.allSources.on("after-add", ({ item }) => {
        item.resultSymbol = new SimpleMarkerSymbol({
          color: new Color([124,187,223,1]),
          outline: new SimpleLineSymbol({
          cap: "round",
          color: new Color([14,80,119,1]),
          join: "round",
          miterLimit: 1,
          style: "solid",
          width: 2
        }),
        path: "undefined",
        size: 21,
        style: "circle",
        xoffset: 0,
        yoffset: 0
            });
      });

      //searchWidget.on("suggest-complete", function(event){
        // The results are stored in the event Object[]     
      //});

      const fillSymbol = {
        type: "simple-fill",
        color: [0, 89, 132, 0.8],
        outline: {
          color: [0, 43, 64],
          width: 3,
        },
      };

      const template = {
        // autocasts as new PopupTemplate()
        title: "{county} in {o_address1}",
        content: "",
      };

      let att = null;
      searchWidget.on("select-result", function (result) {
        result.result.feature.symbol = fillSymbol;
        result.result.feature.popupTemplate = template;

        this.view.graphics.add(result.result.feature);
        att = result.result.feature.attributes;
      });

      let x = this;

      let DVsymbol = {
        type: "picture-marker",
        url: window.location.origin + "/DV.png",
        width: "231px",
        height: "88px",
        xoffset: "-110px",
        yoffset: "-52px"
      };

      let DWsymbol = {
        type: "picture-marker",
        url: window.location.origin + "/DW.png",
        width: "231px",
        height: "88px",
        xoffset: "117px",
        yoffset: "46px"     
      };

      const pointGraphicDV = new Graphic({
          geometry: {
            type: "point",
            longitude: -81.690,
            latitude: 28.876
          },
          symbol: DVsymbol
        });

      const pointGraphicDW = new Graphic({
          geometry: {
            type: "point",
            longitude: -81.373,
            latitude: 29.015
          },
          symbol: DWsymbol
        });

      this.view.graphics.addMany([pointGraphicDV,pointGraphicDW]);

      this.view.on("click", function (event) {
        // the comment has been disabled on click -----------------------
        // --------------------------------------------------------------
        return false;
        // --------------------------------------------------------------
        /*
        x.view
          .hitTest(event, { include: x.view.graphics })
          .then(function (response1) {
            if(att != null){
              x.formData.Field = att.OBJECTID;
              if (response1.results.length) {
                // console.log('att :>> ', att);
                console.log('point: ', event.mapPoint);
                document.getElementById("info").style.visibility = "visible";
                document.getElementById("info").style.right = "0";
                document.getElementById("info").style.opacity = "1";
                document
                  .getElementById("info")
                  .setAttribute("aria-hidden", false);

                document.getElementById("name").innerHTML =
                  "Parcel ID: " + att.pid + (typeof att.dor_reclass != 'undefined' ? " (" + att.dor_reclass + ")": "");
                document.getElementById("category").innerHTML =
                  "<b>County:</b> " + att.county + "<br>" +
                  (att.s_city_o != null? "<b>City:</b> " + att.s_city_o + "<br>": "") +
                  (att.s_address1 != null && att.s_address1.trim() != ''
                    ? "<b>Site Address:</b> " + att.s_address1 + "<br>"
                    : "<b>Site City:</b> " + att.s_city_o + "(" + att.s_zip_o + ")");
                    x.geometryData = event.mapPoint.clone();
                  x.geometryData.z = undefined;
                  x.geometryData.hasZ = false;
              }
            }else{
              console.log(event.mapPoint);
              document.getElementById("info").style.visibility = "visible";
                document.getElementById("info").style.right = "0";
                document.getElementById("info").style.opacity = "1";
                document
                  .getElementById("info")
                  .setAttribute("aria-hidden", false);

                document.getElementById("name").innerHTML = "Comment on selected point on map";
                document.getElementById("category").innerHTML =
                  "<b>Lon:</b> " +
                  event.mapPoint.longitude.toFixed(3) +
                  "<br>" + 
                  "<b>Lat:</b> " +
                  event.mapPoint.latitude.toFixed(3) +
                  "<br>";
                  x.geometryData = event.mapPoint.clone();
                  x.geometryData.z = undefined;
                  x.geometryData.hasZ = false;
    
            }
          });
          */
      });

      let zoom = new Zoom({
        view: this.view,
      });
            let helpExpand = new Expand({ //esri-icon-description
                expandIconClass: "esri-icon-question", // see https://developers.arcgis.com/javascript/latest/guide/esri-icon-font/
                // expandTooltip: "Expand LayerList", // optional, defaults to "Expand" for English locale
                view: this.view,
                content: document.getElementById("inform"),
                expanded: true
            });

      let homeWidget = new Home({
        view: this.view
      });

      // adds the home widget to the top left corner of the MapView
      this.view.ui.add(homeWidget,{ 
        position: "top-left",
        icon:"gps-on-f",
        label: "re-center the map"
      });

      this.view.ui.add(zoom, "bottom-right");
      this.view.ui.add(basemapExpand, "top-left");
      this.view.ui.add(helpExpand, "top-right");
      this.view.ui.add(searchWidget, {
        position: "top-left",
        index: 0
      });
      /*
      this.view.ui.add("inform", {
        position: "top-right",
      });
      */

      let legend = new Legend({
        view: this.view,
        layerInfos: [
          {
            layer: this.corridorLayer,
            title: "Selected Corridor For New Line:"
          },
          {
            layer: this.trasmlineLayer,
            title: "Existing Duke Energy Transmission Line:"   
          },
          {
            layer: this.substationsLayer,
            title: "Substations:"   
          },
          {
            layer: this.proposedLayer,
            title: "Selected Transmission Route:" 
          }

        ]
      });
      
      let legendExpand = new Expand({
        expandIconClass: "esri-icon-legend", // see https://developers.arcgis.com/javascript/latest/guide/esri-icon-font/
        // expandTooltip: "Expand LayerList", // optional, defaults to "Expand" for English locale
        view: this.view,
        content: legend,
      });

      this.view.ui.add(legendExpand, "top-left");
    },
    hideInfo() {
      //inverto gli stili della spalla all'originale, per nasconderla
      document.getElementById("info").style.visibility = "hidden";
      document.getElementById("info").style.opacity = "0.2";
      document.getElementById("info").style.right = "-50%";

      document.getElementById("info").setAttribute("aria-hidden", true);
      document.getElementById("category").setAttribute("tabindex", "-1");

      this.showCommentSection = false;

      //ritorna al focus dell'ultimo punto selezionato
      if (this.lastbutton)
        document
          .getElementById(this.lastbutton)
          .children[0].children[0].children[0].focus();

      //click simulato che non apre la spalla, per chiudere la proprietà 'expanded' dello screen reader
      if (this.lastbutton)
        document
          .getElementById(this.lastbutton)
          .children[0].children[0].children[0].click();

      //solo ora chiudiamo veramente la spalla nella logica della mappa
      this.showspalla = false;
    },
  },
  mounted() {
    //entire page listens to 'm' key pressed to return focus to map wrapper for navigation
    console.log('object :>> ', this.content.esri);
    window.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.hideInfo();
      }
    });

    this.createMapAndLayers(); //create map and all provided layers

    //this.zoomViewModel = new ZoomViewModel();
    //this.zoomViewModel.view = this.view;

    //this.view.ui.add("zoomer", "bottom-left");

    this.view.when().then(function () {
      document.getElementById("loader").style.visibility = "hidden";
    });

    //hide points without a label on the multiterminal layer (punto in mezzo al mare nascosto)
    //this.multiterminalLayer.definitionExpression = "LABEL <> ''"

    //manage click and selection events on map canvas
  },
};
</script>

<style lang="scss" scoped>
/* #info,
#close-spalla,*/
#zoomer,
#zoomout,
#measure {
  display: none;
}
#inform {
  position: relative;
  padding: 14px;
  border-radius: 5px;
  width: 500px;
}

.loader {
  position: absolute;
  width: 100vw;
  height: 100%;
  z-index: 1000;
  pointer-events: none;
  background: url(/img/bg-intro.7e6dba88.jpg) center no-repeat;
  background-size: cover;
  top: 0;
  left: 0;

  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  p {
    color: #fff;
    font-size: 1.5em;
  }
}

.map-wrapper.main-content {
  margin: 0;
  width: 100vh;
  height: 100vh;
  position: absolute;
  top: 0;
  transform: none;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 0;
}

#info {
  background-color: #fff;
  //height: 100%;
  height: calc(100% - 100px);
  //top: 0;
  overflow-y: scroll;
  bottom: 0;
  padding: 0;
  width: 500px;
  z-index: 99;
  right: -50%;
  position: fixed;
  opacity: 1;
  visibility: hidden;
  font-size: 16px;
  transition: all 300ms ease-in-out;

  .intro {
    /* background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.6)),
      url("../assets/header-bg.jpg"); */
    background-color: #005984;
  }

  .intro,
  .intro p {
    color: #fff;
    font-weight: 500;
    font-size: 18pt;
    margin: 0;
  }

  .intro h2 {
    color: #fff;
    font-weight: 500;
    margin-bottom: 0;
  }

  .intro p {
    bottom: 10%;
  }

  .intro {
    position: relative;
    //padding-top: 150px;
    padding-top: 100px;
    padding-left: 50px;
    padding-right: 50px;
    margin-bottom: 20px;
    padding-bottom: 40px;
  }

  #comment-button {
    background: transparent;
    color: #005984;
    font-weight: 700;
    text-align: left;
    padding-left: 20px;
    margin: 10px;
    width: calc(100% - 20px);
    &::after {
      background: url("../assets/caret-down.png");
      background-repeat: no-repeat;
      background-size: contain;
      position: absolute;
      content: "";
      width: 0.75em;
      height: 0.75em;
      top: 50%;
      left: 100px;
      transform: translateY(-50%);
    }
    &.drop::after {
      transform-origin: center center;
      transform: translateY(-50%) scaleY(-1);
    }
    &:hover {
      box-shadow: none;
      background-color: rgba(#005984, 0.1);
    }
  }

  #comment-section {
    padding: 1em;
    padding-right: 40px;
    line-height: 1.5em;
    margin: 0 10px;
    background-color: #ededed;
  }

  #category {
    padding: 30px;
    padding-right: 50px;
    line-height: 1.5em;
    ::v-deep li {
      counter-increment: my-awesome-counter;
      position: relative;
    }
    ::v-deep ol {
      counter-reset: my-awesome-counter;
      list-style: none;
    }
    ::v-deep li::before {
      content: counter(my-awesome-counter) ".";
      color: #005984;
      font-size: 1.1em;
      top: -0.1em;
      font-weight: 700;
      position: absolute;
      left: -1.5em;
    }
  }

  .close {
    cursor: pointer;
    //background-image: url(../assets/close-button.svg);
    background: url(../assets/close.png) content-box, #005984 border-box;
    padding: 20px;
    background-position: center center;
    background-size: contain;
    display: block;
    border-radius: 0;
    //background-color: #005984;
    //background-color: #005984;
    color: #fff;
    width: 70px;
    height: 70px;
    //position: fixed;
    position: absolute;
    z-index: 9;
    //top: 10vh;
    /* &:hover { box-shadow: none; } */
  }
}

@media (max-width: 1200px) {
  .map-wrapper {
    margin-top: -235px;
    height: calc(100vh - 90px);
    width: calc(100vw - 5%);
  }
}

@media (max-width: 1024px) {
  .map-wrapper {
    width: 100vw;
    margin-left: 0;
    height: calc(100vh - 164px);
  }
}

#viewDiv {
  width: 100vw;
  height: calc(100% - 96px);
  position: relative;
  bottom: 0;
  top: 96px;
}

.esri-popup .esri-popup__main-container .esri-popup__footer {
  /*display: none !important;*/
}


h3.esri-widget__heading {
    color: #005984;
    visibility: hidden;
    display: none;
}
.esriLegendServiceLabel {
    display:none;
}

#measure button,
#zoomout {
  background: rgb(239, 239, 239);
  color: black;
  padding: 10px;
  &:hover {
    background: #005984;
    color: #fff;
  }
  &.active {
    background: #005984;
    color: #fff;
  }
}

.active {
  background: #005984;
  color: #fff;
}
.esri-widget--button {
  padding: 10px;
  background-color: white;
  border: 1px solid #ccc;
  cursor: pointer;
}



#zoomer {
  button {
    background: #005984;
    color: #fff;
    padding: 10px;
    &:first-child {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-right: 1px #fff solid;
    }
    &:last-child {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
}

@media (max-width: 1200px) {
  #info {
    width: 576px;
    .intro {
      padding-top: 100px;
    }
    #comment-section,
    #category {
      padding: 30px 90px;
    }
  }
}

@media (max-width: 1024px) {
  #info {
    width: auto;
    transition: none;
    .intro {
      padding-left: 20px;
      padding-right: 20px;
    }
    #commnet-section,
    #category {
      padding: 30px 20px 190px;
    }
  }
}

@media (max-width: 992px) {
  .map-wrapper {
    height: calc(100% - 185px);
    position: absolute;
  }
}

@media (max-width: 768px) {
  #viewDiv {
    height: calc(100% - 57px);
    top: 57px;
  }

  .map-wrapper {
    height: calc(100% - 165px);
    position: absolute;
  }
}
</style>